"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gatewayReducer = exports.INITIAL_STATE = void 0;
const reducer_1 = require("../loading/reducer");
const actions_1 = require("../gateway/actions");
const actions_2 = require("./actions");
exports.INITIAL_STATE = {
    data: { purchases: [] },
    loading: [],
    error: null
};
function gatewayReducer(state = exports.INITIAL_STATE, action) {
    switch (action.type) {
        case actions_2.OPEN_BUY_MANA_WITH_FIAT_MODAL_REQUEST: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error: null });
        }
        case actions_2.OPEN_BUY_MANA_WITH_FIAT_MODAL_SUCCESS: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action) });
        }
        case actions_2.OPEN_BUY_MANA_WITH_FIAT_MODAL_FAILURE: {
            const { error } = action.payload;
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error });
        }
        case actions_2.OPEN_MANA_FIAT_GATEWAY_REQUEST: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error: null });
        }
        case actions_2.OPEN_MANA_FIAT_GATEWAY_SUCCESS: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action) });
        }
        case actions_2.OPEN_MANA_FIAT_GATEWAY_FAILURE: {
            const { error } = action.payload;
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error });
        }
        case actions_2.MANA_FIAT_GATEWAY_PURCHASE_COMPLETED_FAILURE: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error: action.payload.error });
        }
        case actions_1.SET_PURCHASE: {
            const { purchase } = action.payload;
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { purchases: [
                        ...state.data.purchases.filter(_purchase => _purchase.id !== purchase.id),
                        purchase
                    ] }) });
        }
        case actions_1.POLL_PURCHASE_STATUS_REQUEST: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error: null });
        }
        case actions_1.POLL_PURCHASE_STATUS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action) });
        }
        case actions_1.POLL_PURCHASE_STATUS_FAILURE: {
            const { error } = action.payload;
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error });
        }
        default:
            return state;
    }
}
exports.gatewayReducer = gatewayReducer;
//# sourceMappingURL=reducer.js.map